// extracted by mini-css-extract-plugin
module.exports = {"block":"selectSetValue_block_3Yyi2","icon":"selectSetValue_icon_ZjP4G"};